import { Component, Input, OnInit } from '@angular/core';
import { ConfigurationService } from 'src/app/services/core/configuration/configuration.service';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
import { getShiftDays } from '../../../../utils/utils.common'
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { LosService } from 'src/app/services/core/levelOfService/los.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ActivatedRoute } from '@angular/router';
import { sortBy } from 'lodash';
import * as moment from 'moment';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { UserPermission } from 'src/app/enums/enums';
import { PermissionService } from 'src/app/services/app/permission-access-service/permissionBased.service';
import { FundingSourceService } from 'src/app/services/core/funding-source/funding-source.service';
@UntilDestroy()

@Component({
  selector: 'app-fare-list',
  templateUrl: './fare-list.component.html',
  styleUrls: ['./fare-list.component.css']
})
export class FareListComponent implements OnInit {

  @Input() companyId:any;
  fundingSourceId:any;
  fares:any = [];
  levelofservices:any;
  preLevelOfServices:any = {};
  spacetypes:any;
  preSpacetypes:any = {};
  search:any;
  currentPage: number = 1;
  totalPages = 0;
  totalResults = 0;
  numberOfRecords = NUMBER_OF_RECORDS
  filteredFareList:any = [];
  days = getShiftDays;
  status = true;
  user:any;
  timeZone:any;
  logObj:any;
  selectedDropdownIndex:any;
  toggleActionButtons = false;
  userPermission=UserPermission
  fundingSourceDetails: any;

  constructor(
    private route : ActivatedRoute,
    private spaceTypeService : SpaceTypeService,
    private levelOfService: LosService,
    private sharedDataService : SharedDataService,
    private cedentialService : CredentialService,
    public permissionService: PermissionService,
    private fundingSourceService: FundingSourceService
  ){}

  ngOnInit(): void {
    this.fundingSourceId = this.route.snapshot.params['fundingSourceId'];
    this.getUser();
  }


  getUser() {
    this.sharedDataService.getUser().pipe(untilDestroyed(this)).subscribe(data => {
      if (data) {
        this.user = data;
        this.timeZone = this.user.timeZone;

        if (this.fundingSourceId) {
          this.getFundingSourceById();
          this.getFundingSourceWiseFares(this.currentPage);
        } else if (this.companyId) {
          this.getCompanyWiseFares(this.currentPage);
        }
        // this.getCompanyWiseFares(this.currentPage);
        this.getLevelOfService();
        this.getSpaceType();
      }
    })
  }

  getFundingSourceById() {
    this.fundingSourceService
      .getById(this.fundingSourceId)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data) {
          this.fundingSourceDetails = data;
        }
      });
  }

  getCompanyWiseFares(page:number){
    let queryParams = {
      limit : 50,
      page,
      isActive: this.status,
      sortBy: 'createdAt:desc',

    }
    this.cedentialService.getCompanyFares(this.companyId, queryParams).pipe(untilDestroyed(this)).subscribe((data:any)=>{
      if(data && data.results){
         this.fares = data.results.map((fare: any) => {

           const startTimeUTC = moment.utc(fare.startTime).format("YYYY-MM-DDTHH:mm:ss");
           const endTimeUTC = moment.utc(fare.endTime).format("YYYY-MM-DDTHH:mm:ss");

          return {
            ...fare,
            startTime: this.convertUTCToCompanyTime(startTimeUTC),
            endTime: this.convertUTCToCompanyTime(endTimeUTC),
          };
        });

        this.fares.sort((a: any, b: any) =>
          moment(b.startTime).diff(moment(a.startTime))
        );

        this.filteredFareList = [...this.fares]
        this.totalPages = data.totalPages;
        this.totalResults = data.totalResults;
      }
    })
  }

  getFundingSourceWiseFares(page:number){
    let queryParams = {
      limit : 50,
      page,
      isActive: this.status,
      sortBy: 'createdAt:desc',
    }
    this.cedentialService.getfundingSourceFares(this.fundingSourceId, queryParams).pipe(untilDestroyed(this)).subscribe((data:any)=>{
      if(data && data.results){
         this.fares = data.results.map((fare: any) => {

           const startTimeUTC = moment.utc(fare.startTime).format("YYYY-MM-DDTHH:mm:ss");
           const endTimeUTC = moment.utc(fare.endTime).format("YYYY-MM-DDTHH:mm:ss");

          return {
            ...fare,
            startTime: this.convertUTCToCompanyTime(startTimeUTC),
            endTime: this.convertUTCToCompanyTime(endTimeUTC),
          };
        });
        
         this.fares.sort((a: any, b: any) =>
          moment(b.startTime).diff(moment(a.startTime))
        );
        this.filteredFareList = [...this.fares]
        this.totalPages = data.totalPages;
        this.totalResults = data.totalResults;
      }
    })
  }

  // GET los
  getLevelOfService() {
    let queryParams = {
      limit: 9999,
      isActive: true,
    }
    this.levelOfService.getPicker(queryParams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results ) {
          this.levelofservices = data.results;
          this.preLevelOfServices = this.levelofservices.reduce((obj:any, item:any) => (obj[item.id] = item, obj), {});
        }
      })
  }

  // Get SpceType
  getSpaceType() {
    let queryParams = {
      limit: 9999,
      isActive: true,
    }
    this.spaceTypeService.getPicker(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results ) {
        this.spacetypes = data.results;
        this.preSpacetypes = this.spacetypes.reduce((obj:any, item:any) => (obj[item.id] = item, obj), {});
      }
    })
  }

  getEditLink(fareId: any) {
    if (this.fundingSourceId) {
      return `/funding-sources/${this.fundingSourceId}/fare/${fareId}/edit`;
    } else {
      return `/credentials/company/${this.companyId}/fare/${fareId}/edit`;
    }
  }
  

  onPageChange(page: number) {
    this.currentPage = page;
  if (this.fundingSourceId) {
      this.getFundingSourceWiseFares(this.currentPage);
    } else if (this.companyId) {
      this.getCompanyWiseFares(this.currentPage);
    }

  }

  onSelectStatus(): void {
  if (this.fundingSourceId) {
      this.getFundingSourceWiseFares(this.currentPage);
    } else if (this.companyId) {
      this.getCompanyWiseFares(this.currentPage = 1);
    }
  
  }

  getDayLabels(days:any) {
    return days
      .sort((a:any, b:any) => a - b)
      .map((day:any) => getShiftDays.find(d => d.day === day)?.label || '');
  }

    convertUTCToCompanyTime(utcTime: string) {
    const formatted = moment.utc(utcTime).format("YYYY-MM-DDTHH:mm:ss");
    return moment.tz(formatted, "YYYY-MM-DDTHH:mm:ss", this.timeZone).toISOString();
  }

  openLogModal(fare:any){
    this.logObj = fare.id;
  }
}
